var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useInfiniteQuery } from '@tanstack/react-query';
import { getChatSessions } from '../services/chatSessionsApi';
const CONVERSATIONS_KEY = ['ai-chat', 'conversations'];
/**
 * Reusable infinite-scroll conversation list hook.
 * Shared between ChatWidgetDrawer and SearchConversationPopup.
 * Uses the same React Query cache key so both consumers share data — no duplicate fetches.
 * Now backed by Rails /api/v1/ai/chat_sessions with pagination.
 */
export function useGetConversations() {
    const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage, error } = useInfiniteQuery({
        queryKey: CONVERSATIONS_KEY,
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam = 1 }) {
            const result = yield getChatSessions({ page: pageParam, perPage: 20 });
            return {
                conversations: result.conversations,
                nextPage: result.meta.current_page < result.meta.total_pages ? result.meta.current_page + 1 : undefined
            };
        }),
        getNextPageParam: (lastPage) => lastPage.nextPage,
        refetchOnWindowFocus: false,
        staleTime: 30000
    });
    const conversations = data ? data.pages.flatMap((page) => page.conversations) : [];
    return {
        conversations,
        isLoading,
        isFetchingNextPage,
        hasNextPage: hasNextPage !== null && hasNextPage !== void 0 ? hasNextPage : false,
        fetchNextPage: () => {
            void fetchNextPage();
        },
        error: error instanceof Error ? error : null
    };
}
